import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { ClasseEquipamento } from '../pages/domain/domain.model';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class ClasseEquipamentoService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.url = '';
        this.url = SCAMP_API.accountApiV1;
    }
    getById(id) {
        return this.http.get(`${this.url}/classe-equipamento/${id}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${this.url}/classe-equipamentos`, { headers: this.account.composeHeaders() });
    }
    save(model) {
        return this.http.post(`${this.url}/classe-equipamento`, model, { headers: this.account.composeHeaders() });
    }
    isUniqueDescricao(descricao, id) {
        return this.http.get(`${this.url}/classe-equipamento/isunique-descricao/${descricao}/${id}`, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${this.url}/classe-equipamento/${id}`, { headers: this.account.composeHeaders() });
    }
}
ClasseEquipamentoService.ngInjectableDef = i0.defineInjectable({ factory: function ClasseEquipamentoService_Factory() { return new ClasseEquipamentoService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: ClasseEquipamentoService, providedIn: "root" });
